export interface ValueLine {
  label: string
  value: string
}
/** Where the "$707 real value" comes from — shown in the offer and final-call blocks. */
export const valueStack: ValueLine[] = [
  { label: '6 kompletnych tomów dydaktycznych', value: '$407' },
  { label: '6 darmowych bonusów (6 × $50)', value: '$300' },
]
export const TOTAL_VALUE = '$707'
export const PRICE = '$35'
export const SAVINGS = '$672'
export const PRICE_PLN = 'ok. 130 zł'
export const CURRENCY_NOTE = 'Płacisz w USD — Twój bank automatycznie przeliczy kwotę na złote.'
